document.addEventListener("DOMContentLoaded", function () {
  /* ----------------------
     MULTIPLE SECTIONS HANDLING
  ---------------------- */
  document.querySelectorAll(".collection-product").forEach(section => {
    /* ----------------------
       TAB SWITCHING
    ---------------------- */
    const tabItems = section.querySelectorAll(".collection-tab-item");
    const productBlocks = section.querySelectorAll(".collection-block");
    const viewAllLink = section.querySelector(".view-all-link");

    tabItems.forEach(tab => {
      tab.addEventListener("click", () => {
        tabItems.forEach(t => t.classList.remove("active"));
        tab.classList.add("active");

        const target = tab.dataset.handle;
        
        // Hide all product blocks first
        productBlocks.forEach(block => {
          block.classList.add("hidden");
          // Show the block that corresponds to the clicked tab
          if (block.id === `collection-${target}`) {
            block.classList.remove("hidden");
          }
        });

        // Update "View All" link dynamically
        if (viewAllLink) {
          const collectionHandle = tab.dataset.handle;
          if (collectionHandle) {
            viewAllLink.setAttribute("href", "/collections/" + collectionHandle);
            viewAllLink.setAttribute(
              "aria-label",
              "View all " + tab.textContent.trim()
            );
          }
        }
      });
    });

    /* ----------------------
       DRAGGABLE TABS
    ---------------------- */
    const tabContainer = section.querySelector(".collection-tab");

    if (tabContainer) {
      let isDown = false;
      let startX;
      let scrollLeft;

      tabContainer.addEventListener("mousedown", (e) => {
        isDown = true;
        tabContainer.classList.add("dragging");
        startX = e.pageX - tabContainer.offsetLeft;
        scrollLeft = tabContainer.scrollLeft;
      });

      tabContainer.addEventListener("mouseleave", () => {
        isDown = false;
        tabContainer.classList.remove("dragging");
      });

      tabContainer.addEventListener("mouseup", () => {
        isDown = false;
        tabContainer.classList.remove("dragging");
      });

      tabContainer.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - tabContainer.offsetLeft;
        const walk = (x - startX) * 2; // drag speed factor
        tabContainer.scrollLeft = scrollLeft - walk;
      });

      // Touch support
      tabContainer.addEventListener("touchstart", (e) => {
        startX = e.touches[0].pageX - tabContainer.offsetLeft;
        scrollLeft = tabContainer.scrollLeft;
      });

      tabContainer.addEventListener("touchmove", (e) => {
        const x = e.touches[0].pageX - tabContainer.offsetLeft;
        const walk = (x - startX) * 2;
        tabContainer.scrollLeft = scrollLeft - walk;
      });
    }
  });
});
